import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getChainModels,
  createChainModel,
  updateChainModel,
  deleteChainModel,
} from '../api/chainModels';
import { ChainModel } from 'types/ChainModel';

export const useChainModels = () =>
  useQuery({
    queryKey: ['chain-models'],
    queryFn: getChainModels,
    staleTime: 5 * 60 * 1000,
  });

export const useCreateChainModel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (
      data: Omit<ChainModel, 'id' | 'creation_ts' | 'edit_ts' | 'resolved_model'>
    ) => createChainModel(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chain-models'] });
    },
  });
};

export const useUpdateChainModel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<ChainModel> }) =>
      updateChainModel(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chain-models'] });
    },
  });
};

export const useDeleteChainModel = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteChainModel,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['chain-models'] });
    },
  });
};
